import { Injectable } from '@angular/core';
import { Chunk, IndexedChunkItem } from '@shared/components/infinite-scroll/infinite-scroll.component';
import { Observable, ReplaySubject } from 'rxjs';
import { AnyLoc } from 'src/generated-sources';

export interface CellData {
    itemPath: string,
    imageId: number
}

@Injectable()
export abstract class ImagesDataFetcherService {
    CHUNK_SIZE = 64;

    projectKey: string;
    managedFolderLoc: AnyLoc;

    // refetch the chunk
    private refetchDataTrigger$ = new ReplaySubject<void>(1);
    dataRefetch$: Observable<void> = this.refetchDataTrigger$.asObservable();

    // update an individual item in the chunk
    private updateItemTrigger$ = new ReplaySubject<IndexedChunkItem>(1);
    itemUpdate$: Observable<IndexedChunkItem> = this.updateItemTrigger$.asObservable();

    abstract getChunk(offset: number): Observable<Chunk>;

    abstract getImagePath(itemPath: string): string;

    refetchData(): void {
        this.refetchDataTrigger$.next();
    }

    updateItem(index: number, item: any): void {
        this.updateItemTrigger$.next({
            index,
            item
        });
    }
}
